var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonalOften(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Plans/Often") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 29.9996 0 29.9996 15.938 0 15.938"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Plans/Often",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(-0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4059,3.7267 C12.0229,3.7267 11.6639,3.4907 11.5249,3.1107 L11.0209,1.7267 C10.8429,1.2397 11.0939,0.7027 11.5799,0.5247 C12.0659,0.3487 12.6059,0.5987 12.7819,1.0847 L13.2869,2.4677 C13.4639,2.9537 13.2129,3.4927 12.7269,3.6697 C12.6209,3.7087 12.5129,3.7267 12.4059,3.7267",
    id: "Fill-1",
    fill: "#FF7822"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5933,3.7267 C17.4863,3.7267 17.3783,3.7087 17.2723,3.6697 C16.7863,3.4927 16.5353,2.9537 16.7123,2.4677 L17.2173,1.0847 C17.3933,0.5987 17.9333,0.3487 18.4193,0.5247 C18.9053,0.7027 19.1563,1.2397 18.9783,1.7267 L18.4743,3.1107 C18.3353,3.4907 17.9763,3.7267 17.5933,3.7267",
    id: "Fill-3",
    fill: "#FF7822"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.6367,
    y1: 10.6087,
    x2: 2.9937,
    y2: 11.2997,
    id: "Stroke-5",
    stroke: "#FF7822",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3499,7.9647 C5.1559,7.9647 4.9599,7.9047 4.7919,7.7797 L3.5449,6.8537 C3.1279,6.5447 3.0419,5.9577 3.3499,5.5427 C3.6599,5.1267 4.2469,5.0397 4.6619,5.3477 L5.9089,6.2747 C6.3259,6.5827 6.4119,7.1697 6.1029,7.5857 C5.9189,7.8337 5.6369,7.9647 5.3499,7.9647",
    id: "Fill-7",
    fill: "#FF7822"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.224,14.063 C25.946,10.713 24.198,7.781 21.628,5.903 L22.781,4.451 C23.392,4.902 23.95,5.417 24.473,5.964 L24.055,6.275 C23.64,6.583 23.552,7.17 23.861,7.586 C24.045,7.834 24.328,7.965 24.614,7.965 C24.809,7.965 25.005,7.904 25.172,7.78 L25.683,7.4 C26.288,8.245 26.785,9.167 27.177,10.143 L26.545,10.465 C26.084,10.699 25.901,11.264 26.136,11.726 C26.301,12.051 26.63,12.237 26.972,12.237 C27.115,12.237 27.26,12.204 27.397,12.135 L27.747,11.956 C27.911,12.642 28.04,13.341 28.092,14.063 L26.224,14.063 Z M20.014,4.92 C18.501,4.165 16.802,3.729 15,3.729 C13.197,3.729 11.498,4.165 9.986,4.92 L8.809,3.439 C10.655,2.446 12.761,1.875 15,1.875 C17.239,1.875 19.344,2.446 21.191,3.439 L20.014,4.92 Z M3.775,14.063 L1.908,14.063 C2.187,10.124 4.219,6.669 7.218,4.451 L8.372,5.903 C5.801,7.781 4.053,10.713 3.775,14.063 L3.775,14.063 Z M15,12.093 C15.459,12.093 15.834,12.466 15.834,12.926 C15.834,13.386 15.459,13.76 15,13.76 C14.54,13.76 14.166,13.386 14.166,12.926 C14.166,12.466 14.54,12.093 15,12.093 L15,12.093 Z M23.234,2.477 C23.217,2.462 23.21,2.441 23.192,2.427 C23.116,2.366 23.029,2.333 22.944,2.3 C20.637,0.852 17.919,0 15,0 C12.082,0 9.365,0.851 7.059,2.298 C6.972,2.331 6.884,2.365 6.807,2.427 C6.79,2.441 6.782,2.462 6.765,2.477 C2.695,5.162 0,9.77 0,15 C0,15.519 0.419,15.938 0.937,15.938 L19.972,15.938 C20.49,15.938 20.909,15.519 20.909,15 C20.909,14.482 20.49,14.063 19.972,14.063 L17.45,14.063 C17.612,13.716 17.709,13.333 17.709,12.926 C17.709,11.433 16.494,10.218 15,10.218 C13.505,10.218 12.291,11.433 12.291,12.926 C12.291,13.333 12.388,13.716 12.549,14.063 L5.65,14.063 C6.122,9.32 10.134,5.604 15,5.604 C19.865,5.604 23.877,9.32 24.349,14.063 L23.366,14.063 C22.848,14.063 22.428,14.482 22.428,15 C22.428,15.519 22.848,15.938 23.366,15.938 L29.062,15.938 C29.58,15.938 30,15.519 30,15 C30,9.77 27.304,5.162 23.234,2.477 L23.234,2.477 Z",
    id: "Fill-9",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.9996,13.8634 C14.4816,13.8634 14.0626,13.4444 14.0626,12.9264 L14.0626,3.4544 C14.0626,2.9364 14.4816,2.5174 14.9996,2.5174 C15.5176,2.5174 15.9366,2.9364 15.9366,3.4544 L15.9366,12.9264 C15.9366,13.4444 15.5176,13.8634 14.9996,13.8634",
    id: "Fill-12",
    fill: "#FF7822"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalOften);
export default __webpack_public_path__ + "static/media/personal_often.a706958e45df389f3caeaeeed3be2025.svg";
export { ForwardRef as ReactComponent };